{
  "message": "{{type}} не найден"
}
